module.exports = __webpack_public_path__ + "img/vertical_4_5_4.d61d11c9.png";